import React, { useCallback } from "react";

import VimeoPlayer from "@vimeo/player";
import cn from "classnames";

import styles from "./VimeoVideo.module.scss";

interface Props {
  allow?: string;
  className?: string;
  onClick?: () => void;
  title?: string;
  videoClassName?: string;
  videoId: string;
}

const VimeoVideo: React.FC<Props> = ({
  allow = "autoplay; fullscreen; picture-in-picture",
  className,
  onClick,
  title,
  videoClassName,
  videoId,
}) => {
  const refIframe = useCallback(
    (iframeRef: HTMLIFrameElement) => {
      if (onClick && iframeRef) {
        new VimeoPlayer(iframeRef).on("play", () => onClick());
      }
    },
    [onClick]
  );
  return (
    <div className={cn(styles.container, className)} onClick={onClick}>
      <iframe
        allow={allow}
        allowFullScreen
        className={videoClassName}
        frameBorder="0"
        // TODO: specify locale for `texttrack` according to current user's locale
        ref={refIframe}
        src={`https://player.vimeo.com/video/${videoId}?texttrack=en`}
        title={title}
      />
    </div>
  );
};

export default VimeoVideo;
